import {openWithParams} from "./main_ptx";
import {getFunction} from "./main_system";


/**
 * submit form via ajax, useable for ajax file upload!!
 * @alias Ptx.form.submit
 * @param form - jQ object for form
 * @param callback - what to do after response is returned (params: data, srv status)
 * @param opts optional options (opts.useDefaultSerialization if wanna use form.serialize() instead of FormData)
 */
export function submit(form, callback, opts) {
	var $form = $(form);
	// grab all form data
	var formData;
	var ajaxOpts = opts || {};
	
	var defaultSerialization = ajaxOpts.useDefaultSerialization;
	if (defaultSerialization) {
		formData = $form.serialize();
	} else {
	  formData = new FormData($form[0]);
	  ajaxOpts['contentType'] = false;
	  ajaxOpts['processData'] = false;
	  ajaxOpts['locationName'] = "form";
	}
	var urlPath = $form.attr('action');
	var method = $form.attr('method');

	Ptx.form.ajax = openWithParams(urlPath, method, formData, callback, ajaxOpts);
}

/**
 * submit current form with default options - current is that where this ele is
 * @alias Ptx.form.submitCurrent
 * @param ele
 * @param defaultSelector - where to place response,
 * @param defaultCallback action after response (url,data,srv) both may be undefined
 * @param opts - optional options for Ptx.form.submit
 * override behaviour with html <form ..... data-target-selector="#targetId" data-callback="Ptx.functionName">
 */
export function submitCurrent(ele, defaultSelector, defaultCallback, opts) {
    var f = ele.closest('form');
    //add hidden input for current submit button to form
    var hiddenName = ele.attr('name');
    var submitName = ele.data('submit-name');
    if (submitName) {
        hiddenName = submitName;
    }

    var hidden = $('<input type="hidden" name="'+hiddenName+'"/>');
    f.append(hidden);
	
	var tgt = f.data('target-selector') || defaultSelector;
	var callback = defaultCallback;
	var tabPane = f.closest(".tab-pane");
	if (f.closest(".tab-pane").is(function(){
			return $(this).parent().find(".tab-pane:first-child").attr("id") !== $(this).attr("id");
		})
	){
		tgt = tabPane;
	}
    var callbackDataVal = f.data('callback');
	if (callbackDataVal) {
		const callbackFunc = getFunction(callbackDataVal, window);

		if(typeof callbackFunc === "function") callback = callbackFunc;
	}
	function fullCallback(data, srv) {
		if (tgt && srv.isHtml) {
			var $target = $(tgt);
			if ($target.length && $target.length > 0) {
				$target.html(data);
			}
		}
		if (callback) callback(data, srv, tgt, ele.data("close-modal"));
	}
    var formSerializationDataVal = ele.data('form-serialization');
    if (formSerializationDataVal && formSerializationDataVal === 'default'){
        opts = opts || {useDefaultSerialization : true};
    }
	Ptx.form.ctx = {};
	submit(f, fullCallback, opts)
}

/**
 * remove error text and class from form
 * @alias Ptx.form.removeErrors
 * @param ctx
 */
export function removeErrors(ctx) {
	$('.has-error', ctx).removeClass("has-error");
	$('.text-danger', ctx).remove();
}

/**
 * When called, this function will look for select tags that have the sortType (JSP) / data-ptx-sort parameter.
 * Currently supported sorting: Alphabetically, Numerically
 * example usage in JSP: sortType="alphabet"
 * Recommended to use only with static data
 * @alias Ptx.fn.selectSort
 * @param $select - jQuery object that gets targeted with this function
 * @param allValue values from f-select tag
 * @param noneValue values from f-select tag
 */
export function selectSort($select, allValue, noneValue) {
	const ele = $select;
	const options = ele.find('option');
	const defaultOption = options.filter(':selected');
	const sortAttributeValue = ele.attr('data-ptx-sort');

	if (!sortAttributeValue) {
		return;
	}
	const sortAlphabetically = sortAttributeValue === 'alphabet';
	const sortNumerically = sortAttributeValue === 'numeric';

	options.sort((a, b) => {
		const aValue = $(a).val();
		const bValue = $(b).val();

		switch (true) {
			case aValue === noneValue:
				return -1;
			case aValue === allValue:
				return 1;
			case bValue === noneValue:
				return 1;
			case bValue === allValue:
				return -1;
			default:
				const aText = $(a).text().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
				const bText = $(b).text().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

				if (sortAlphabetically) {
					return aText.localeCompare(bText);
				}

				if (sortNumerically) {
					const aValue = parseFloat($(a).val());
					const bValue = parseFloat($(b).val());
					return aValue - bValue;
				}

				return 0;
		}
	});

	ele.empty().append(options);
	ele.val(defaultOption.val());
}

/**
 * When called, this function will initialize the dropzone element from a file-input.
 * @alias Ptx.fn.initializeDropzone
 * @param element - jQuery object that gets targeted with this function (passed from JSP)
 * @param input - file input element inside the container
 * @param $fileNameInput - label for the file name (will be automatically filled in if exists)
 * @param $previewContainer - dropzone container which shows the image/file info
 */
export function initializeDropzone(element, ctx) {
	var $element = $(element, ctx);

	$element.on('dragover', function() {
		$element.addClass('hover');
	});

	$element.on('dragleave', function() {
		$element.removeClass('hover');
	});

	$element.find('input').off('change').on('change', function(e) {
		var file = this.files[0];

		$element.removeClass('hover');

		var $fileNameInput = $('#fileName');
		$fileNameInput.length > 0 && $fileNameInput.val(file.name);

		$element.addClass('dropped');
		$element.find('img').remove();

		var $previewContainer = $element.find('.dropzone-content');
		$previewContainer.empty();

		var fileInfoHTML = `
            <span class="text-bold">${Ptx.getMsg("common.file.name")}:</span> ${file.name}<br>
            <span class="text-bold">${Ptx.getMsg("common.file.size")}:</span> ${formatFileSize(file.size)}
        `;

		if (/^image\/(gif|png|jpeg)$/i.test(file.type)) {
			var reader = new FileReader();
			reader.readAsDataURL(file);

			reader.onload = function(e) {
				var data = e.target.result,
						$img = $('<img />').attr('src', data).fadeIn(),
						$info = $('<div />').addClass('file-info').html(fileInfoHTML);
				$previewContainer.prepend($img, $info);
			};
		} else {
			var $info = $('<div />').addClass('file-info').html(`<i class="fa-solid fa-file" style="font-size: 90px;"></i><br>${fileInfoHTML}`);
			$previewContainer.prepend($info);
		}
	});
}

function formatFileSize(bytes) {
	if (bytes === 0) return '0 Bytes';

	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
	const i = Math.floor(Math.log(bytes) / Math.log(1024));
	return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + sizes[i];
}